import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "leaflet/dist/leaflet.css";
import { runServiceWorkerReset } from "@/lib/serviceWorkerReset";

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        (async () => {
            await runServiceWorkerReset();
            navigator.serviceWorker.register('/service-worker.js')
                .then(reg => {
                    console.log('SW registered!', reg);
                    // Check for updates on page load
                    reg.update();
                })
                .catch(err => console.log('SW registration failed: ', err));

            // Reload page when new Service Worker takes control
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('New Service Worker activated, reloading page...');
                window.location.reload();
            });
        })();
    });
}

createRoot(document.getElementById("root")!).render(<App />);
